import { useQuery } from '@tanstack/react-query'

import useEmptyStateStore from '../../../hooks/isEmptyState/useEmptyStateStore'
import { request } from '../../../lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'
import { Domain } from '../../../types/domain'
import { useUserStore } from 'Stores/userStoreModuleFed'

export type UserDomainResponse = { domains: Domain[] }

export const getUserDomains = async (
  userId: number,
  accountId: number
): Promise<UserDomainResponse | Error> => {
  return await request<UserDomainResponse>({
    url: `/users/${userId}/accounts/${accountId}/domains`,
    method: 'GET',
  })
}

type QueryFnType = typeof getUserDomains

export const useGetUserDomains = ({ config }: { config?: QueryConfig<QueryFnType> } = {}) => {
  const { userId, accountId } = useUserStore()
  const { showPmDashboard } = useEmptyStateStore()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getUserDomains', userId],
    queryFn: () => {
      showPmDashboard({ getUserDomains: false })
      return getUserDomains(userId, accountId || 1)
    },
    onSettled: () => {
      showPmDashboard({ getUserDomains: true })
    },
    ...config,
  })

  const data = query.data instanceof Error ? null : query.data

  return { ...query, data }
}
